import React, { createContext, useContext, useMemo, useRef, useState } from 'react';
import LoginModal from '../components/LoginModal/LoginModal';

const LoginModalContext = createContext({
  isOpen: false,
  openLoginModal: () => {},
  closeLoginModal: () => {},
  setLoginSuccessCallback: () => {}
});

export const LoginModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const loginSuccessCallbackRef = useRef(null);

  const openLoginModal = () => setIsOpen(true);
  const closeLoginModal = () => setIsOpen(false);
  const setLoginSuccessCallback = (fn) => { loginSuccessCallbackRef.current = fn; };
  const handleLoginSuccess = () => {
    setIsOpen(false);
    loginSuccessCallbackRef.current?.();
  };

  const value = useMemo(() => ({
    isOpen,
    openLoginModal,
    closeLoginModal,
    setLoginSuccessCallback
  }), [isOpen]);

  return (
    <LoginModalContext.Provider value={value}>
      {children}
      <LoginModal isOpen={isOpen} onClose={closeLoginModal} onLoginSuccess={handleLoginSuccess} />
    </LoginModalContext.Provider>
  );
};

export const useLoginModal = () => useContext(LoginModalContext);
